import PropTypes from 'prop-types';

/**
 * Business hours for a single day
 */
export const BusinessHoursDayPropType = PropTypes.shape({
  /**
   * True if the business is closed for the entire day.
   */
  closed: PropTypes.bool.isRequired,

  /**
   * Date this schedule is for
   */
  day: PropTypes.instanceOf(Date).isRequired,

  /**
   * Date and time the business opens for this day
   * 0 if the business does not open this day.
   */
  startTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]).isRequired,

  /**
   * Date and time the business closes for this day
   * 0 if the business does not open this day.
   */
  endTime: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]).isRequired,
});

export const ProviderProductPropType = PropTypes.shape({
  id: PropTypes.number,
  provider: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  creation_time: PropTypes.string,
  modification_time: PropTypes.string,
});
